import { ChangeEventArgs, Switch } from '@syncfusion/ej2-buttons';

import { routes } from '@/shared/routes';
import { EditableClientProps, EditableRequestBody } from '@/shared/types/editable';

import { input } from '@/front/editable/input';
import { addValidation, maybeNegate, setControl } from '@/front/editable/state';
import { change } from '@/front/editable/utils';
import { POST } from '@/front/fetch';

export const initSwitch = (p: EditableClientProps, e: HTMLElement) => {
  const swtch = new Switch({
    checked: maybeNegate(p, p.value === true || p.value === 'true'), // For boolean custom field (maps from text)
    disabled: p.readOnly,
  });

  setControl(p.id, swtch);

  if (!p.modelId || p.editMode === 'Form') {
    if (p.save !== false) {
      swtch.change = change(e);
    }

    addValidation(p, e);

    swtch.appendTo(input(p, e));
  } else {
    swtch.change = async (args: ChangeEventArgs) => {
      const body: EditableRequestBody = {
        params: {
          name: p.field,
          primaryKey: p.modelId,
          value: maybeNegate(p, args.checked),
        },
      };

      await POST(routes.data.editable({ model: p.modelName }), body);
    };

    swtch.appendTo(e);
  }
};
